<template>
  <div class="c-scale">
    <p class="c-scale__question" v-if="question">{{ question }}</p>
    <div class="c-scale__answer">
      <span class="c-scale__label">{{ labelLeft }}</span>
      <div class="c-scale__items">
        <input
          type="radio"
          v-for="answer in answers"
          class="c-scale__button"
          :name="uniqueId"
          :key="answer"
          :value="answer"
          @change="changeValue"
          :checked="answer === value"
        >
      </div>
      <span class="c-scale__label c-scale__label--right">{{ labelRight }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: String
    },
    amount: {
      type: Number,
      required: true
    },
    value: {
      type: Number
    },
    labelLeft: {
      type: String,
      default: 'Laag'
    },
    labelRight: {
      type: String,
      default: 'Hoog'
    }
  },
  computed: {
    answers () {
      let items = []
      for (let i = 1; i <= this.amount; i++) {
        items.push(i)
      }
      return items
    },
    uniqueId () {
      return '_' + Math.random().toString(36).substr(2, 9)
    }
  },
  methods: {
    changeValue (e) {
      this.$emit('input', parseInt(e.target.value))
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/variables.scss';

.c-scale {
  margin-bottom: 3.2rem;
}

.c-scale__question {
  font-size: 1.8rem;
  font-weight: 600;
}

.c-scale__answer {
  align-items: center;
  display: flex;
}

.c-scale__label {
  color: $blue-light;
  flex: none;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 1.6rem;
  margin-right: 1.6rem;
  text-transform: uppercase;
}

.c-scale__label--right {
  margin-left: 1.6rem;
  margin-right: 0;
  text-align: right;
}

.c-scale__items {
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
  position: relative;
  will-change: transform;

  &:before {
    background-color: $blue;
    content: '';
    height: 2px;
    left: 0;
    position: absolute;
    top: calc(50% - 1px);
    width: 100%;
    z-index: 0;
  }
}

.c-scale__button {
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: $black;
  border: 2px solid $blue;
  border-radius: 1.6rem;
  flex: none;
  height: 2.4rem;
  margin: 0;
  outline: 0;
  padding: 0;
  position: relative;
  transition: all 0.15s linear;
  width: 2.4rem;
  z-index: 1;

  &:checked {
    background-color: #FFF;
    border-color: #FFF;
  }

  &:focus {
    box-shadow: 0 0 0 4px $black, 0 0 0 6px $blue;
  }
}

@media (max-width: $bp-small) {
  .c-scale__answer {
    flex-wrap: wrap;
  }

  .c-scale__label {
    margin: 0 0 0.8rem 0;
    order: 1;
    width: 50%;
  }

  .c-scale__label--right {
    order: 2;
  }

  .c-scale__items {
    order: 3;
  }
}
</style>
